module.exports = __webpack_public_path__ + "static/media/party-popper-emoji.b7094857.png";